<template>
    <div class="page">
        <ion-grid fixed>
            <ion-row class="row-divider"></ion-row>
            <ion-row class="rectangle">
                <ion-col>
                    <ion-row align-items-stretch>
                        <ion-col size="12" size-md="4" class="col-padding">
                            <ion-label class="border-text" position="stacked">
                                Type
                                <span class="required">*</span>
                            </ion-label>
                            <div class="border-line select-mobile">
                                <ion-select
                                    class="form-select"
                                    :value="vhtype"
                                    @ionChange="changeType($event)"
                                    placeholder="Select Type"
                                    interface="action-sheet"
                                >
                                <ion-select-option
                                    v-for="(vhtype, index) in this.vhtypes"
                                    :key="index"
                                    :value="vhtype.id"
                                >{{vhtype.name}}</ion-select-option>
                                </ion-select>
                            </div>
                            <div class="border-line select-web">
                                <select class="input-select" v-model="vhtype" @change="changeType($event)" placeholder="Select Type">
                                    <option
                                        v-for="(vhtype, index) in this.vhtypes"
                                        :key="index"
                                        :value="vhtype.id"
                                        
                                    >{{vhtype.name}}</option>
                                </select>
                            </div>
                        </ion-col>
                        <ion-col size="12" size-md="4" class="col-padding">
                            <ion-label class="border-text" position="stacked">
                                Make
                                <span class="required">*</span>
                            </ion-label>
                            <div class="border-line select-mobile" :class="{'view-hide' : (vhtype == '')}">
                                <ion-select
                                    class="form-select"
                                    :value="vhmake"
                                    @ionChange="changeMake($event)"
                                    placeholder="Select Make"
                                    interface="action-sheet"
                                >
                                <ion-select-option
                                    v-for="(vhmake, index) in this.vhmakes"
                                    :key="index"
                                    :value="vhmake.id"
                                >{{vhmake.name}}</ion-select-option>
                                </ion-select>
                            </div>
                            <div class="border-line select-web" :class="{'view-hide' : (vhtype == '')}">
                                <select class="input-select" v-model="vhmake" @change="changeMake($event)" placeholder="Select Make">
                                    <option
                                        v-for="(vhmake, index) in this.vhmakes"
                                        :key="index"
                                        :value="vhmake.id"
                                    >{{vhmake.name}}</option>
                                </select>
                            </div>
                        </ion-col>
                        <ion-col size="12" size-md="4" class="col-padding">
                            <ion-label class="border-text" position="stacked">
                                Model
                                <span class="required">*</span>
                            </ion-label>
                            <div class="border-line select-mobile" :class="{'view-hide' : (vhmake == null)}">
                                <ion-select
                                    class="form-select"
                                    :value="vhmodel"
                                    @ionChange="vhmodel = $event.target.value"
                                    placeholder="Select Model"
                                    interface="action-sheet"
                                >
                                <ion-select-option
                                    v-for="(vhmodel, index) in this.vhmodels"
                                    :key="index"
                                    :value="vhmodel.id"
                                >{{vhmodel.name}}</ion-select-option>
                                </ion-select>
                            </div>
                            <div class="border-line select-web" :class="{'view-hide' : (vhmake == null)}">
                                <select class="input-select" v-model="vhmodel" @change="vhmodel = $event.target.value" placeholder="Select Model">
                                    <option
                                        v-for="(vhmodel, index) in this.vhmodels"
                                        :key="index"
                                        :value="vhmodel.id"
                                    >{{vhmodel.name}}</option>
                                </select>
                            </div>
                        </ion-col>
                    </ion-row>
                    <ion-row align-items-stretch>
                        <!-- SCMT 2.0 migration start-->
                        <!-- <ion-col size="12" size-md="4" class="col-padding">
                            <ion-label class="border-text" position="stacked">
                                Year of Manufacture
                                <span class="required">*</span>
                            </ion-label>
                            <div class="border-line">
                                <ion-input
                                    class="form-input"
                                    type="text"
                                    placeholder="Enter Year of Manufacture"
                                    @input="vhyear = $event.target.value"
                                    :value="vhyear"
                                    maxlength="4"
                                ></ion-input>
                            </div>
                        </ion-col> -->
                        <!-- SCMT 2.0 migration end-->
                        <ion-col size="12" size-md="4" class="col-padding">
                        
                            <ion-label class="border-text" position="stacked">
                                Vehicle Reg.No/VIN
                                <span class="required">*</span>
                            </ion-label>
                            <div class="border-line">
                                <ion-input
                                    class="form-input"
                                    type="text"
                                    placeholder="Enter Vehicle Registration No. / VIN No"
                                    @input="vhregno = $event.target.value"
                                    :value="vhregno"
                                    maxlength="17"
                                ></ion-input>
                            </div>
                        </ion-col>
                        <!-- SCMT 2.0 migration start -->
                        <!-- <ion-col size="12" size-md="4" class="col-padding">
                            <ion-label class="border-text" position="stacked">
                                Socket Type
                                <span class="required">*</span>
                            </ion-label>
                            <div class="border-line select-mobile" :class="{'view-hide' : (vhmake == null)}">
                                <ion-select
                                    class="form-select"
                                    :value="vhsocket"
                                    @ionChange="vhsocket = $event.target.value"
                                    placeholder="Select Socket Type"
                                    interface="action-sheet"
                                >
                                <ion-select-option
                                    v-for="(vhsocket, index) in this.vhsockets"
                                    :key="index"
                                    :value="vhsocket.id"
                                >{{vhsocket.name}}</ion-select-option>
                                </ion-select>
                            </div>
                            <div class="border-line select-web" :class="{'view-hide' : (vhmake == null)}">
                                <select class="input-select" v-model="vhsocket" @change="vhsocket = $event.target.value" placeholder="Select Socket Type">
                                    <option
                                        v-for="(vhsocket, index) in this.vhsockets"
                                        :key="index"
                                        :value="vhsocket.id"
                                >{{vhsocket.name}}</option>
                                </select>
                            </div>
                        </ion-col> -->
                        <!-- SCMT 2.0 migration end -->
                         <!-- ONboard power is disabled as per siva sir request 18-02-2025 -->
                        <!-- <ion-col size="12" size-md="4" class="col-padding">
                            <ion-label class="border-text" position="stacked">
                                Onboard Power
                            </ion-label>
                            <div class="border-line">
                                <ion-input
                                    class="form-input"
                                    type="number"
                                    placeholder="Enter OnBoard Power"
                                    @input="onboardPower = $event.target.value"
                                    :value="onboardPower"
                                ></ion-input>
                            </div>
                        </ion-col> -->
                    </ion-row>
                    <!-- <ion-row align-items-stretch>
                        <ion-col size="12" size-md="4" class="col-padding">
                            <ion-label class="border-text" position="stacked">
                                Onboard Power
                            </ion-label>
                            <div class="border-line">
                                <ion-input
                                    class="form-input"
                                    type="number"
                                    placeholder="Enter OnBoard Power"
                                    @input="onboardPower = $event.target.value"
                                    :value="onboardPower"
                                ></ion-input>
                            </div>
                        </ion-col>
                    </ion-row> -->
                </ion-col>
            </ion-row>
        </ion-grid>
        <div>
            <ion-button class="btn-primary" expand="full" @click="saveVechicle">SAVE</ion-button>
        </div>
        <div class="spinner">
            <ion-spinner v-if="loaderTab"></ion-spinner>
        </div>
    </div>
</template>

<script>
import { defineComponent } from "vue";
import { IonGrid, IonRow, IonCol, IonLabel, IonList, IonItem, IonSelect, IonSelectOption, IonInput, IonSpinner } from "@ionic/vue";

import { AuthenticationService } from "../../service/account/authenticator.service";
import { VehicleService } from "../../service/vehicle/vehicle.service";

import { LocalStorage } from "../../data/localstorage";
import { Credential } from "../../entity/authentication/credential";
import { VehicleModel } from "../../entity/vehicle/model";
import { VehicleType } from "../../entity/vehicle/type";
import { VehicleMake } from "../../entity/vehicle/make";
import { VehicleChargeSocketType } from "../../entity/vehicle/charge-socket-type";
import { VehicleStatus } from "../../entity/vehicle/vehicle-status";
import { Vehicle } from "../../entity/vehicle/vehicle";
import { User } from "../../entity/authentication/user";

import { ValidationUtils } from "../../util/validation-utils";
import { ToastUtils } from "../../util/toast-utils";
import { AlertUtils } from "../../util/alert-utils";

import { tryParseServiceError, migratedTryParseServiceError } from "../../service";

export default defineComponent ({
    name: 'eVehicleDetail',
    components: {
        IonGrid, IonRow, IonCol, IonLabel, IonSelect, IonSelectOption, IonInput, IonSpinner,IonList, IonItem
    },
    data() {
        return {
            loaderTab: true,
            mode: "ADD",
            user: null,
            vehicleId: "",
            vhtypes: [],
            vhmodels: [],
            vhmakes: [],
            vhsockets: [],
            vhyear: "",
            vhregno: "",
            vhtype: "",
            vhmodel: "",
            vhmake: null,
            vhsocket: "",
            onboardPower : ""
        }
    },
    async mounted() {
        try {
            this.user = new LocalStorage().user;
            this.vhtypes = await new VehicleService().types();
            if (this.$route.params.vehicleId && this.$route.params.vehicleId != 'R') {
                let vehicle = await new VehicleService().vehicleWithId(
                    this.$route.params.vehicleId
                );
                this.fillVehicle(vehicle);
            }
            this.loaderTab = false;
        } catch(error) {
            this.loaderTab = false;
            // new ToastUtils().presentToast(error.response.data.errors[0].detail);
            let serviceError = migratedTryParseServiceError(error);
            new ToastUtils().presentToast(serviceError.description);
        }
        
    },
    methods: {
        async fillVehicle(vehicle) {
            try {
                this.mode = "UPDATE";
                this.vehicleId = vehicle.id;
                this.vhyear = vehicle.yearOfManufacturing;
                this.vhregno = vehicle.regNo;
                this.vhtype = vehicle.type.id;
                this.onboardPower = vehicle.onboardPower;
                this.vhmakes = await new VehicleService().makesOfType(
                    new VehicleType(this.vhtype)
                );
                this.vhmake = vehicle.make.id;
                this.vhmodels = await new VehicleService().modelsOfMake(
                    new VehicleMake(this.vhmake, "")
                );
                this.vhmodel = vehicle.model.id;
                this.vhsockets = await new VehicleService().chargerSocketTypesOfVehicleType(
                    new VehicleType(this.vhtype)
                );
                this.vhsocket = vehicle.socketType.id;
            } catch(error) {
                let serviceError = migratedTryParseServiceError(error);
                new ToastUtils().presentToast(serviceError.description);
            }
            
        },
        async changeType(event) {
            try {
                this.vhtype = event.target.value;
                this.vhmake = null;
                this.vhmodel = null;
                this.vhsocket = null;
                this.vhmakes = await new VehicleService().makesOfType(
                    new VehicleType(this.vhtype)
                );
                this.vhsockets = await new VehicleService().chargerSocketTypesOfVehicleType(
                    new VehicleType(this.vhtype)
                );
            } catch(error) {
                let serviceError = migratedTryParseServiceError(error);
                new ToastUtils().presentToast(serviceError.description);

            }
            
        },
        async changeMake(event) {
            try {
                this.vhmake = event.target.value;
                this.vhmodels = await new VehicleService().modelsOfMake(
                    new VehicleMake(this.vhmake, "")
                );
            } catch(error) {
                let serviceError = migratedTryParseServiceError(error);
                new ToastUtils().presentToast(serviceError.description);

            }
            
        },
        async saveVechicle() {
            try {
                if (
                typeof this.vhtype === "undefined" ||
                this.vhtype === null ||
                this.vhtype === ""
                ) {
                    new ToastUtils().presentToast("Select Vechicle Type");
                } else if (
                typeof this.vhmake === "undefined" ||
                this.vhmake === null ||
                this.vhmake === ""
                ) {
                    new ToastUtils().presentToast("Select Vechicle Make");
                } else if (
                typeof this.vhmodel === "undefined" ||
                this.vhmodel === null ||
                this.vhmodel === ""
                ) {
                    new ToastUtils().presentToast("Select Vechicle Model");
                } 
                // SCMT 2.0 migration start
                // else if (
                // typeof this.vhyear === "undefined" ||
                // this.vhyear === null ||
                // this.vhyear === ""
                // ) {
                //     new ToastUtils().presentToast("Enter Year of Manufacture");
                // } 
                
                // else if (new ValidationUtils().year(this.vhyear) === false) {
                //     new ToastUtils().presentToast("Enter Valid Year of Manufacture");
                // } else if (this.vhyear < 2000) {
                //     new ToastUtils().presentToast("Enter Year of Manufacture after 2000");
                // } 
                // SCMT 2.0 migration end
                else if (
                typeof this.vhregno === "undefined" ||
                this.vhregno === null ||
                this.vhregno === "" ||
                this.vhregno.trim().length == 0
                ) {
                    new ToastUtils().presentToast("Enter Registration No. / VIN No");
                } else if(new ValidationUtils().restrictSpecialChar(this.vhregno) === false)  {
                    new ToastUtils().presentToast("Enter Valid Registration No. / VIN No");
                } 
                // SCMT 2.0 migration start
                // else if (
                // typeof this.vhsocket === "undefined" ||
                // this.vhsocket === null ||
                // this.vhsocket === ""
                // ) {
                //     new ToastUtils().presentToast("Select Socket Type");
                // } 
                // SCMT 2.0 migration end

                else if(Math.sign(this.onboardPower) == -1 || this.onboardPower == 0 ? this.onboardPower : '') {
                    new ToastUtils().presentToast(
                    "Onboard Power Allow only number"
                    );
                    this.onboardPower = "";
                }
                else {
                let vehicle = null;
                if (this.mode == "ADD") {
                    if (
                    this.$route.params.vehicleType &&
                    this.$route.params.vehicleType === "U"
                    ) {
                        vehicle = await new VehicleService().addVehicleForReservationForUser(
                            new Vehicle(
                                undefined,
                                new VehicleType(this.vhtype),
                                new VehicleMake(this.vhmake),
                                new VehicleModel(this.vhmodel),
                                this.vhregno,
                                this.onboardPower,
                                new VehicleChargeSocketType(this.vhsocket),
                                this.vhyear
                            ),
                            this.user
                        );
                    } else {
                        vehicle = await new VehicleService().addVehicleOfUser(
                            new Vehicle(
                                undefined,
                                new VehicleType(this.vhtype),
                                new VehicleMake(this.vhmake),
                                new VehicleModel(this.vhmodel),
                                this.vhregno,
                                this.onboardPower,
                                new VehicleChargeSocketType(this.vhsocket),
                                this.vhyear
                            ),
                            this.user
                        );
                    }
                } else {
                    vehicle = await new VehicleService().updateVehicleOfUser(
                        new Vehicle(
                            this.vehicleId,
                            new VehicleType(this.vhtype),
                            new VehicleMake(this.vhmake),
                            new VehicleModel(this.vhmodel),
                            this.vhregno,
                            this.onboardPower,
                            new VehicleChargeSocketType(this.vhsocket),
                            this.vhyear
                        ),
                        this.user
                    );
                }
                new ToastUtils().presentToast("E-Vehicle saved successfully");
                if (localStorage.getItem("vehiclePath") == "true" || localStorage.getItem('previousPath') == "unregistervehicle") {
                        localStorage.setItem("vehicle", JSON.stringify(vehicle));
                        this.$router.push({ name: "slotBooking" });
                    } else {
                        this.$router.back();
                    }
                }
            } catch (error) {
                // let serviceError = tryParseServiceError(error);
                // new AlertUtils().presentAlert(serviceError ? serviceError : error);
                // new ToastUtils().presentToast(error.response.data.errors[0].detail);
                let serviceError = migratedTryParseServiceError(error);
                new ToastUtils().presentToast(serviceError.description);
            }
        }
    }
})
</script>

<style scoped>
    .view-hide{
        opacity: 0.4;
        pointer-events: none;
    }
</style>